import React from "react";
import { StyledLoader, LoaderContainer } from "./styles";

export default function Loader({ inContainer = false, styles }) {
  const loader = (
    <StyledLoader style={styles}>
      <img src="/images/logos/bouncing-logo.svg" alt="bouncing-logo" />
    </StyledLoader>
  );

  if (inContainer) {
    return <LoaderContainer>{loader}</LoaderContainer>;
  }

  return loader;
}
